import React, { useState } from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { restructure6111 } from "../../../../utils/a6111/restructure6111";
import useMetrics from "./useMetrics";

const BalanceMetrics = () => {
  const { t } = useTranslation();
  const [active, setActive] = useState("all");

  const { display, list, filterDisplay } = useMetrics();

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <Breadcrumbs
          maintitle={t("balanceSheetMetrics")}
          title="الرئيسية"
          subtitle={t("balanceSheetMetrics")}
          // modal="#warning-alert-modal"
        />

        <div className="card mt-3">
          <div className="card-body">
            <ul className="nav nav-tabs nav-tabs-solid nav-justified">
              <li className="nav-item">
                <Link
                  to="#"
                  data-bs-toggle="tab"
                  className={active == "all" ? "nav-link active" : "nav-link"}
                  onClick={() => {
                    filterDisplay();
                    setActive("all");
                  }}
                >
                  {t("showAll")}
                </Link>
              </li>
              {list.map((item) => (
                <li className="nav-item">
                  <Link
                    to="#"
                    data-bs-toggle="tab"
                    className={
                      active == item.type ? "nav-link active" : "nav-link"
                    }
                    key={item.type}
                    onClick={() => {
                      filterDisplay(item.type);
                      setActive(item.type);
                    }}
                  >
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {display.map((item) => (
          <div
            className="card dash-widget col-md-8 m-auto  mb-4 pt-3"
            key={item.type}
          >
            <div className="card-body col-md-6 border-div rounded-2 primary balance justify-content-between mt-4">
              <div className="dash-widget-info text-right">
                <h3 className="text-primary d-flex justify-content-between  ">
                  {item.title}

                  <span className="fs-3 text-success   fw-bold ">
                    {" "}
                    {item.result}
                  </span>
                </h3>
              </div>
              <span className="dash-widget-icon  ms-0">
                <i className="fa fa-percent" />
              </span>
            </div>
            <div className="card-body">
              <div className="row mb-3">
                <div className="col-8 description">
                  <p>{item.description}</p>
                  <hr className="text-primary" />
                  <span className="text-info ">{item.function}</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BalanceMetrics;
